import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import useHttp from "../../../hook/use-http";
import moment from "moment";
import { ThreeCircles } from "react-loader-spinner";
import { Chart } from "react-google-charts";
import NoData_Coral from "./NoData_Coral";
import ChartLoader_Coral from "./ChartLoader_Coral";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitialstates_coral";
import BuketsTable_Coral from "./BuketsTable_Coral";
import * as $ from "jquery";

function RangeErc_Coral({ apiend, gloablfilter, title }) {
  const [chartdata, setChartData] = useState([]);
  const [apiresponce, SetApiResponce] = useState([]);
  const [filteredData, SetfilteredData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  let modal_title = title;

  const appyData = (data) => {
    const res_result = data;

    let responce = {
      "0-60": 0,
      "60-70": 0,
      "70-80": 0,
      "80-90": 0,
      "90-100": 0,
      "100-110": 0,
      "110-120": 0,
      "120-130": 0,
      "130-140": 0,
      "140-150": 0,
      "150-160": 0,
      "160-170": 0,
      "170-180": 0,
      "180-190": 0,
      ">=190": 0,
    };

    if (res_result.length != 0) {
      SetApiResponce(res_result);
      let temp_result = res_result;
      temp_result.map((d) => {
        if (
          d.discharge_cycle.doc_count > gloablfilter.DISCHARGE &&
          (d.deltaOdo.value === 0
            ? d.deltaOdo.value >= gloablfilter.DELTA
            : d.deltaOdo.value > gloablfilter.DELTA)
        ) {
          let value = d.Range.values["50.0"];
          if (value >= 0 && value < 60) {
            responce["0-60"] = responce["0-60"] + 1;
          } else if (value >= 60 && value < 70) {
            responce["60-70"] = responce["60-70"] + 1;
          } else if (value >= 70 && value < 80) {
            responce["70-80"] = responce["70-80"] + 1;
          } else if (value >= 80 && value < 90) {
            responce["80-90"] = responce["80-90"] + 1;
          } else if (value >= 90 && value < 100) {
            responce["90-100"] = responce["90-100"] + 1;
          } else if (value >= 100 && value < 110) {
            responce["100-110"] = responce["100-110"] + 1;
          } else if (value >= 110 && value < 120) {
            responce["110-120"] = responce["110-120"] + 1;
          } else if (value >= 120 && value < 130) {
            responce["120-130"] = responce["120-130"] + 1;
          } else if (value >= 130 && value < 140) {
            responce["130-140"] = responce["130-140"] + 1;
          } else if (value >= 140 && value < 150) {
            responce["140-150"] = responce["140-150"] + 1;
          } else if (value >= 150 && value < 160) {
            responce["150-160"] = responce["150-160"] + 1;
          } else if (value >= 160 && value < 170) {
            responce["160-170"] = responce["160-170"] + 1;
          } else if (value >= 170 && value < 180) {
            responce["170-180"] = responce["170-180"] + 1;
          } else if (value >= 180 && value < 190) {
            responce["180-190"] = responce["180-190"] + 1;
          } else if (value >= 190) {
            responce[">=190"] = responce[">=190"] + 1;
          }
        }
      });

      let res_result_final = [["Element", "Count", { role: "style" }]];
      let loop_keys = Object.keys(responce);
      loop_keys.map((x) => {
        // res_result_final.push([x, responce[x], "#348393"]);
        res_result_final.push([
          x,
          responce[x],
          "stroke-width: 1;stroke-color: black;color:#348393",
        ]);
      });
      setChartData((prestate) => res_result_final);
    } else {
      setChartData((prestate) => []);
      SetApiResponce((prestate) => []);
    }
  };

  const options = {
    hAxis: {
      gridlines: {
        color: "transparent",
      },
      title: "Range(Km)",
      minValue: 0,
      format: "short",
      textStyle: {
        fontSize: 8, // Adjust the font size as needed
      },
      slantedText: true, // Enable slanted text
      slantedTextAngle: 60, // Rotate labels to vertical (90 degrees)
    },
    vAxis: {
      gridlines: {
        color: "transparent",
      },
      title: "Vehicle Count",
      minValue: 0,
      format: "short",
    },
    // bar: { groupWidth: "90%" },
    bar: { groupWidth: "100%" },
    legend: "none",
  };

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "coral_drive_analysis/" + apiend,
        body: { filterdata: gloablfilter },
      },
      appyData
    );
  }, [gloablfilter]);

  return (
    <>
      <div className="v-title chartbox drive_graph p-0">
        <div className="titlebg titlebd_drive box_title pb-2 pt-2">{title}</div>
        <div className="chartHGT">
          {isLoading ? (
            <ChartLoader_Coral />
          ) : chartdata.length === 0 ? (
            <NoData_Coral />
          ) : (
            <Chart
              chartType="ColumnChart"
              width="100%"
              height="247px"
              data={chartdata}
              options={options}
              chartEvents={[
                {
                  eventName: "select",
                  // callback: ({ chartWrapper }) => {
                  //   const chart = chartWrapper.getChart();
                  //   const selection = chart.getSelection();
                  //   if (selection.length === 1) {
                  //     const [selectedItem] = selection;
                  //     const { row } = selectedItem;

                  //     const barvalue = parseInt(
                  //       chartWrapper.getDataTable().Wf[row].c[0].v
                  //     );

                  //     const count = chartWrapper.getDataTable().Wf[row].c[1].v;
                  //     let filtered_temp = [];
                  //     if (count != 0) {
                  //       filtered_temp = apiresponce.filter((x) => {
                  //         if (barvalue === ">190") {
                  //           if (
                  //             x.Range.values["50.0"] >= barvalue
                  //             //  &&
                  //             // x.Range.values["50.0"] <= barvalue + 50
                  //           ) {
                  //             return x;
                  //           }
                  //         } else {
                  //           if (
                  //             // x.Range.values["50.0"] <= barvalue &&
                  //             // x.Range.values["50.0"] > barvalue - 20
                  //             x.Range.values["50.0"] >= barvalue &&
                  //             x.Range.values["50.0"] < barvalue + 10
                  //           ) {
                  //             return x;
                  //           }
                  //         }
                  //       });

                  //       function compareObjects(object1, object2, key) {
                  //         const obj1 = object1.Range.values["50.0"];
                  //         const obj2 = object2.Range.values["50.0"];
                  //         if (obj1 > obj2) {
                  //           return -1;
                  //         }
                  //         if (obj1 < obj2) {
                  //           return 1;
                  //         }
                  //         return 0;
                  //       }

                  //       filtered_temp.sort((value1, value2) => {
                  //         return compareObjects(value1, value2, "vehicalId");
                  //       });

                  //       SetfilteredData((prestate) => filtered_temp);
                  //       window.$("#exampleModal__" + apiend).modal("show");
                  //     }
                  //   }
                  // },
                  callback: ({ chartWrapper }) => {
                    const chart = chartWrapper.getChart();
                    const selection = chart.getSelection();
                    if (selection.length === 1) {
                      const [selectedItem] = selection;
                      const { row } = selectedItem;

                      const barLabel =
                        chartWrapper.getDataTable().Wf[row].c[0].v; // Fetch the label directly

                      const count = chartWrapper.getDataTable().Wf[row].c[1].v;
                      let filtered_temp = [];

                      if (count !== 0) {
                        // Handle the case for ">500" explicitly
                        if (barLabel === ">=190") {
                          filtered_temp = apiresponce.filter((x) => {
                            if (
                              x.discharge_cycle.doc_count >
                                gloablfilter.DISCHARGE &&
                              (x.deltaOdo.value === 0
                                ? x.deltaOdo.value >= gloablfilter.DELTA
                                : x.deltaOdo.value > gloablfilter.DELTA)
                            ) {
                              return x.Range.values["50.0"] >= 190;
                            }
                          });
                        } else if (barLabel === "0-60") {
                          filtered_temp = apiresponce.filter((x) => {
                            if (
                              x.discharge_cycle.doc_count >
                                gloablfilter.DISCHARGE && x.deltaOdo.value === 0
                                ? x.deltaOdo.value >= gloablfilter.DELTA
                                : x.deltaOdo.value > gloablfilter.DELTA
                            ) {
                              // return x.Range.values["50.0"] < 60;
                              return (
                                x.Range.values["50.0"] >= 0 &&
                                x.Range.values["50.0"] < 60
                              );
                            }
                          });
                        } else {
                          // Convert barLabel to an integer for other ranges
                          const barvalue = parseInt(barLabel);
                          filtered_temp = apiresponce.filter((x) => {
                            if (
                              x.discharge_cycle.doc_count >
                                gloablfilter.DISCHARGE && x.deltaOdo.value === 0
                                ? x.deltaOdo.value >= gloablfilter.DELTA
                                : x.deltaOdo.value > gloablfilter.DELTA
                            ) {
                              return (
                                x.Range.values["50.0"] >= barvalue &&
                                x.Range.values["50.0"] < barvalue + 10
                              );
                            }
                          });
                        }

                        function compareObjects(object1, object2, key) {
                          const obj1 = object1.Range.values["50.0"];
                          const obj2 = object2.Range.values["50.0"];
                          if (obj1 > obj2) {
                            return -1;
                          }
                          if (obj1 < obj2) {
                            return 1;
                          }
                          return 0;
                        }

                        filtered_temp.sort((value1, value2) => {
                          return compareObjects(value1, value2, "vehicalId");
                        });

                        SetfilteredData((prestate) => filtered_temp);
                        window.$("#exampleModal__" + apiend).modal("show");
                      }
                    }
                  },
                },
              ]}
            />
          )}

          <div
            className="modal fade"
            id={"exampleModal__" + apiend}
            tabIndex={-1}
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    {modal_title}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  />
                </div>
                <div
                  className="modal-body"
                  style={{ overflowY: "scroll", height: "250px" }}
                >
                  <table className="table table-striped">
                    <thead
                      style={{ backgroundColor: "#32879c", color: "#fff" }}
                    >
                      <tr>
                        <th scope="col">Vin Number</th>
                        <th scope="col">value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <BuketsTable_Coral data={filteredData} />
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default RangeErc_Coral;
